<template>
<div class="jzbWrap">
  <div v-if="hasNotice" class="notice-wrap">
    <p class="notice-title">{{notice.noticeType}}</p>
    <p class="notice-subtitle">{{notice.noticeTitle}}</p>
    <div class="notice-content">{{notice.noticeContent}}</div>
  </div>
  <el-tabs v-model="activeTab"  @tab-click="handleClick" v-else>
      <el-tab-pane label="对私提现" name="person" :hasNotice="hasNotice" v-if="jzb_attribute === 'private' || jzb_attribute === 'private-public'">
        <userCash v-if="person" :type="2"></userCash>
      </el-tab-pane>
      <el-tab-pane label="对公提现" name="business" :hasNotice="hasNotice" v-if="jzb_attribute === 'public' || jzb_attribute === 'private-public'">
        <userCash v-if="business" :type="1"></userCash>
      </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import userCash from './userCash'
import {
  jzbQueryNotice
} from '@/models/jzbModel'
export default {
  components: {userCash},
  data () {
    return {
      hasNotice: true,
      notice: {
        noticeTitle: '',
        noticeContent: '',
        noticeType: ''
      },
      jzb_attribute: '',
      activeTab: 'person',
      business: false,
      person: true,
    }
  },
  methods: {
    handleClick (tab) {
      if (tab.name === 'business') {
        this.business = true
      }
      if (tab.name === 'person') {
        this.person = true
      }
    }
  },
  created () {
    jzbQueryNotice().then(res => {
      if (res.code === 200) {
        let data = res.data
        if (data.hasNotice) {
          this.notice.noticeTitle = data.data[0].noticeTitle
          this.notice.noticeContent = data.data[0].noticeContent
          this.notice.noticeType = data.data[0].noticeType === 1 ? '通知' : '公告'
          this.hasNotice = true
        } else {
          this.hasNotice = false
        }
      }
    })
    .catch(error => { // eslint-disable-line
      this.hasNotice = false
    })

    // 获取见证宝账号属性 对公 public 还是 对私 private private-public 两个同时存在
    const value = localStorage.getItem('jzb_attribute');
    this.jzb_attribute = value;
    this.activeTab = value === 'public' ? 'business' : 'person';
    this.business = value === 'public' ? true : false;
    this.person = value === 'private' || value === 'private-public' ? true : false;
  }
}
</script>

<style lang="scss" scoped>
.notice-wrap{
  text-align: center;
}
.notice-content{
  text-align: left;
  margin-top: 20px;
}
.notice-title{
  font-size: 24px;
  font-weight: 600;
  margin: 10px auto;
}
.notice-subtitle{
  margin: 10px auto;
  font-size: 18px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cashTab.vue